// extracted by mini-css-extract-plugin
export var section = "styles-module--section--1gwnk";
export var header = "styles-module--header--2zuI6";
export var title = "styles-module--title--2ET_l";
export var content = "styles-module--content--2N54k";